export const replaceUsernameWithId = (htmlString) => {
  const parsedHTML = new DOMParser().parseFromString(htmlString, "text/html");

  parsedHTML.querySelectorAll("[data-id]").forEach((elem) => {
    elem.innerText = `@{{${elem.dataset.id}}}`;
    elem.dataset.label = `@{{${elem.dataset.id}}}`;
  });

  return parsedHTML.getElementsByTagName("body")[0].innerHTML;
};